/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCustomersToDateHistoryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type ActivityGranularity, type CustomersToDateHistory, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers/todate/history
 */
export interface HistoryRequestBuilder extends BaseRequestBuilder<HistoryRequestBuilder> {
    /**
     * GetCustomersToDateHistory
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CustomersToDateHistory>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<HistoryRequestBuilderGetQueryParameters> | undefined) : Promise<CustomersToDateHistory | undefined>;
    /**
     * GetCustomersToDateHistory
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<HistoryRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * GetCustomersToDateHistory
 */
export interface HistoryRequestBuilderGetQueryParameters {
    granularity?: ActivityGranularity;
}
/**
 * Uri template for the request builder.
 */
export const HistoryRequestBuilderUriTemplate = "{+baseurl}/customers/todate/history?Granularity={Granularity}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const HistoryRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "granularity": "Granularity",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const HistoryRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: HistoryRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCustomersToDateHistoryFromDiscriminatorValue,
        queryParametersMapper: HistoryRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
